var axios = require('axios')

const urlPayment = process.env.version + '/product-payment-fe/payment'
const urlCardInformation = process.env.version + '/product-payment-fe/card-information'

axios.getPaymentStatus = function (transaction, success, callBackError) {
  axios.options.notify = false
  this.get(urlPayment + '/softbankjp/handlestatuspayment?transaction=' + transaction)
    .then(response => {
      success(response)
    }).catch(error => {
      if (error.response && error.response.status === 400) {
        if (typeof callBackError !== 'undefined') {
          callBackError(error.response.data)
        }
      }
    })
}

axios.makeCreditPayment = function (data, success, callBackError) {
  this.post(urlPayment + '/softbankjp/credit-payment', data)
    .then(response => {
      success(response)
    }).catch(error => {
      if (error.response && error.response.status === 400) {
        if (typeof callBackError !== 'undefined') {
          callBackError(error.response.data)
        }
      }
    })
}

axios.getCardInformation = function (email, success, callBackError) {
  axios.options.flag = false
  this.get(urlCardInformation + '?email=' + email)
    .then(response => {
      success(response)
    })
}

axios.getTransactionLog = function (orderNumber, success, callBackError) {
  axios.options.flag = false
  this.get(urlPayment + '/logs/' + orderNumber)
          .then(response => {
            success(response)
          }).catch(error => {
    if (error.response && error.response.status === 400) {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}

axios.removeSavedCard = function (uuid, success, callBackError) {
  this.delete(urlPayment + `/saved-card/${uuid}`).then(response => {
    success(response)
  }).catch(error => {
    if (error.response && error.response.status === 400) {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}

export default axios



// WEBPACK FOOTER //
// ./src/api/Payment.js